// IE11 compatibility
var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
var pageReadyEvent = isIE11 ? 'ready' : 'swup:pageView';

jQuery( document ).on( pageReadyEvent, function () {
  jQuery( document ).trigger( 'page.ready' );
} );

jQuery( function ( $ ) {

  // We are using SWUP to take care of AJAX & History management 🙌
  // https://github.com/gmrchk/swup

  if ( isIE11 ) {
    return;
  }

  var swupOptions = {
    //debugMode: true,
    elements: [ '#page-container', '.full-screen-nav' ],
    animationSelector: '.page-loader',
    plugins: [
      swupGtagPlugin
    ]
  };

  if ( $( '#wpadminbar' ).length ) {
    // let's also switch out the WP Admin Bar if we're logged in
    swupOptions.elements.push( '#wpadminbar' );
  }

  window.theswup = new Swup( swupOptions );

  // Take care of our loader on initial page load
  // by emulating Swup <html> classes
  // ---
  setTimeout( function () {

    $( 'html' ).removeClass( 'is-animating is-leaving' );
    $( 'html' ).addClass( 'is-rendering' );

    setTimeout( function () {
      $( 'html' ).removeClass( 'the-first-page-reveal is-rendering is-changing' );
    }, 3000 );

  }, 1500 );

} );

jQuery( document ).on( 'swup:clickLink', function () {
  setTimeout( function () {
    jQuery( 'html' ).removeClass( 'menu-open' );
  }, 1200 ); // $swupBgDuration
} );

// Run any inline scripts (fixes Gravity Forms)
// ---
jQuery( document ).on( 'swup:contentReplaced', function () {
  $( 'main script' ).each( function () {
    eval( $( this ).html() );
  } )
} );